export class TestimonialSlider {
	constructor( node ) {
		this.node = node;
		// Scroll container is the <ul class="testimonial-slider__track">
		this.track = node.querySelector( '.testimonial-slider__track' );
		this.bullets = node.querySelectorAll( '.testimonial-slider__bullet' );

		if ( ! this.track ) return;

		this.slides = this.track.children;

		this.bullets.forEach( ( btn ) => {
			btn.addEventListener( 'click', () => {
				const index = parseInt( btn.dataset.slideIndex, 10 );
				if ( ! isNaN( index ) ) {
					this.setScrollIndex( index );
				}
			} );
		} );

		this.track.addEventListener( 'scroll', () => this.setState(), { passive: true } );
		this.setScrollIndex( 0 );
		this.setState();
		this._initDrag();
	}

	_initDrag() {
		let dragStartX = 0;
		let lastX = 0;
		let scrollStartLeft = 0;
		let isDragging = false;

		this.track.addEventListener( 'pointerdown', ( e ) => {
			if ( e.pointerType !== 'mouse' ) return;
			isDragging = true;
			dragStartX = e.clientX;
			lastX = e.clientX;
			scrollStartLeft = this.track.scrollLeft;
			this.track.setPointerCapture( e.pointerId );
			this.track.style.scrollSnapType = 'none';
			this.track.style.cursor = 'grabbing';
		} );

		this.track.addEventListener( 'pointermove', ( e ) => {
			if ( ! isDragging ) return;
			lastX = e.clientX;
			// 2x multiplier: small movements feel responsive without needing to drag a full slide width
			this.track.scrollLeft = scrollStartLeft - ( e.clientX - dragStartX ) * 2;
		} );

		const endDrag = () => {
			if ( ! isDragging ) return;
			isDragging = false;
			this.track.style.scrollSnapType = '';
			this.track.style.cursor = '';

			const dragDistance = dragStartX - lastX;
			const slideWidth = this.track.offsetWidth;
			// 80px threshold — a short intentional swipe triggers a slide change
			const threshold = 80;
			const startIndex = Math.round( scrollStartLeft / slideWidth );

			let targetIndex;
			if ( Math.abs( dragDistance ) >= threshold ) {
				const direction = dragDistance > 0 ? 1 : -1;
				targetIndex = Math.max( 0, Math.min( this.slides.length - 1, startIndex + direction ) );
			} else {
				targetIndex = startIndex;
			}

			this.setScrollIndex( targetIndex );
		};

		this.track.addEventListener( 'pointerup', endDrag );
		this.track.addEventListener( 'pointercancel', endDrag );
	}

	setScrollIndex( index ) {
		this.track.scrollTo( {
			left: index * this.track.offsetWidth,
			top: 0,
			behavior: 'smooth',
		} );
	}

	getCurrentIndex() {
		if ( ! this.track.offsetWidth ) return 0;
		return Math.round( this.track.scrollLeft / this.track.offsetWidth );
	}

	setState() {
		const index = this.getCurrentIndex();

		this.bullets.forEach( ( btn, i ) => {
			const active = i === index;
			btn.classList.toggle( 'testimonial-slider__bullet--active', active );
			if ( active ) {
				btn.setAttribute( 'aria-current', 'true' );
			} else {
				btn.removeAttribute( 'aria-current' );
			}
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.testimonial-slider' ).forEach( ( node ) => {
		new TestimonialSlider( node );
	} );
} );
